import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { map, combineLatest } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BaseObject } from '../shared/baseClass';
import { RegistryService } from '../registry/registry.service';
import { AuthService } from '../user/auth.service';

import { Registry } from './registry';
import { Gift } from '../gift/gift';
import { forkJoin } from 'rxjs/observable/forkJoin';

export interface State {
  registry: Registry;
  gifts: Gift[];
}

@Injectable()
export class RegistryStateStore {
  
  
  updateRegistry(registry: Registry) {

    //ensure all property values don't contain undefined, if there are any that is undefined set it to null
    Object.keys(registry).forEach(key => {
      if (registry[key] === undefined) {
        registry[key] = null;
      }
    });

    this.afs
      .collection(this.REGISTRY_COLLECTION_NAME)
      .doc(registry.id)
      .update(registry)
      .then(() => {
       
      })
      .catch(error => {
        console.error('Error updating registry: ', error);
      });
  }
  
  
  private readonly REGISTRY_COLLECTION_NAME = 'registries';
  private userId: string;
  private state$: BehaviorSubject<State>;

  constructor(private afs: AngularFirestore, private authService: AuthService) {
    this.state$ = new BehaviorSubject<State>({
      registry: null,
      gifts: null
    });

    this.authService.user.subscribe(user => {
      if (user) {
        this.userId = user.uid;

        this.afs
          .collection<Registry>(this.REGISTRY_COLLECTION_NAME, ref =>
            ref.where('userId', '==', this.userId)
          )
          .snapshotChanges()
          .pipe(
            map(x => {
              if (x && x.length > 0 && x[0].payload) {
                const registry = x[0].payload.doc.data() as Registry;
                registry.id = x[0].payload.doc.id;
                return registry;
              } else {
                console.error("NO SETTINGS");
                return null;
              }
            })
          )
          .subscribe(registry => {
            if (registry) {
              const newState: State = {
                registry: registry,
                gifts: this.state$.getValue().gifts
              };

             
              this.updateState(newState);
            }
          });

        this.afs
          .collection('registry-gifts', ref => ref.where('userId', '==', this.userId))
          .valueChanges()
          .subscribe(gifts => {
            const newState: State = {
              registry: this.state$.getValue().registry,
              gifts: gifts as Gift[]
            };

          
            this.updateState(newState);
          });
      } else {
        //throw new Error('no user ID supplied: Hitchd crash error');
      }
    });
  }

  getState(): Observable<State> {
    return this.state$.asObservable();
  }

  updateState(newState: State) {
    this.state$.next(newState);
  }
}


// WEBPACK FOOTER //
// ./src/app/registry/registry.state.store.ts